import { render, staticRenderFns } from "./color-choose.vue?vue&type=template&id=6a5f0f41&scoped=true"
import script from "./color-choose.vue?vue&type=script&lang=ts"
export * from "./color-choose.vue?vue&type=script&lang=ts"
import style0 from "./color-choose.vue?vue&type=style&index=0&id=6a5f0f41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f0f41",
  null
  
)

export default component.exports